const InstituteJson = [
  {
    id: 1,
    header: "INTERNATIONAL CERTIFICATION COACHING",
    header1: "",
    subheader1: "A.C.E =American Council on Exercise ",

    description1:
      "The ACE-certified Personal Trainer is proficient in demonstrating knowledge of screening risk factor, fitness assessments, nutrition, exercise science, exercise program design and implementation, instructional and spotting techniques, lifestyle modifications, etc.",
    subheader2: "A.C.S.M = American college of sports medicine",
    description2:
      "The ACSM Certified Personal Trainer (ACSM-CPT) is qualified to plan and implement exercise programs for healthy individuals or those who have medical clearance to exercise. The CPT facilitates motivation and adherence as well as develops and administers programs designed to enhance muscular strength, endurance, flexibility, cardiorespiratory fitness, body composition, and/or any of the motor skill related components of physical fitness - i.e., balance, coordination and reaction time, to name a few. ",

    subheader3: "	NASM = National Academy of Sports Medicine",
    description3:
      "The NASM CPT is based on an evidence-based training model preparing students for real-life situations. In addition to learning and understanding complex scientific principles, students will use NASM’s proprietary Optimum Performance Training™ (OPT™) model, a systematic system that helps you train in various areas including: Flexibility, Cardiorespiratory, Core, Balance, Power, and Strength",
    duration: "16 week ",
    Price: "28000",
    description4: "",
    description5: "",
    description6: ""
  }
];
export default InstituteJson;
